import { render, staticRenderFns } from "./HelpfulInfoArticle4.vue?vue&type=template&id=427f545f&scoped=true"
import script from "./HelpfulInfoArticle4.vue?vue&type=script&lang=js"
export * from "./HelpfulInfoArticle4.vue?vue&type=script&lang=js"
import style0 from "./HelpfulInfoArticle4.vue?vue&type=style&index=0&id=427f545f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427f545f",
  null
  
)

export default component.exports